<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px" lazy>
      <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.stop="show=false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Mutton Buster</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #1</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      :rules="[v => !!v || 'Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company"
                      label="Company Name"
                      ref="focusName"
                      :rules="[v => !!v || 'Company Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.address"
                      label="Address"
                      :rules="[v => !!v || 'Address is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs10 md5>
                        <v-text-field
                          v-model="editedItem.city"
                          label="City"
                          :rules="[v => !!v || 'City is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 md2>
                        <v-text-field
                          v-model="editedItem.state"
                          label="ST"
                          mask="AA"
                          :rules="[v => !!v || 'State is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md5>
                        <v-text-field
                          v-model="editedItem.zip"
                          label="Zipcode"
                          mask="#####"
                          :rules="[v => !!v || 'Zip is required']"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #2</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name2"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email2"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company2"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone2"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize2"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #3</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name3"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email3"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company3"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone3"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize3"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">PLAYER #4</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="person"
                      v-model="editedItem.name4"
                      label="Name"
                      :rules="[v => !!v || 'Name is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      prepend-icon="email"
                      label="Email"
                      type="email"
                      v-model="editedItem.email4"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.company4"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone4"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      v-model="editedItem.shirtSize4"
                      :items="sizes"
                      label="Shirt Size"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CREDIT CARD INFORMATION</span>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span class="title">Includes greens fee, cart, beverages, food and more...</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-radio-group v-model="editedItem.payType" @change="setPrice()">
                            <v-radio
                              label="$775 Foursome no Hole Sponsorship"
                              value="Foursome"
                            ></v-radio>
                            <v-radio
                              label="$1275 Foursome with Hole Sponsorship"
                              value="Foursome/Sponsor"
                            ></v-radio>
                            <v-radio
                              label="$600 Hole Sponsorship"
                              value="Sponsor"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 md3 offset-md1>
                          <v-text-field
                            v-model="editedItem.amount"
                            label="Amount"
                            :rules="[v => !!v || 'Amount is required']"
                            mask="####"
                            prefix="$"
                            readonly
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

export default {
  props: ['visible', 'item'],

  data () {
    return {
      valid: true,
      currentYear: 0,
      saving: false,
      sizes: [ 'S', 'M', 'L', 'XL', 'XXL', 'XXXL' ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: this.item,
      titleName: '',
      dates: [],
      finalsDate: ''
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    this.currentYear = this.$store.state.currentYear

    this.setFields()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    loadItem () {
      this.editedItem = this.item

      this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
    },

    setPrice () {
      console.log(this.editedItem.payType)
      if (this.editedItem.payType === 'Foursome/Sponsor') {
        this.editedItem.amount = 1275
      } else if (this.editedItem.payType === 'Sponsor') {
        this.editedItem.amount = 600
      } else {
        this.editedItem.amount = 775
      }
    },

    setFields () {
      this.editedItem.number = this.editedItem.cardNumber
      this.editedItem.expire = this.editedItem.cardExpire
      this.editedItem.Cvv = this.editedItem.cardCvv
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async printForm (date) {
      try {
        await Api().post('get_pdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/out.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.id > 0) {
          // console.log('Update')
          this.updateItem(this.editedItem)
        } else {
          // console.log('Save')
          this.addItem(this.editedItem)
        }
      } else {
        this.snackbar.message = 'You have some errors on the page!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addItem () {
      try {
        this.editedItem.year = this.currentYear
        console.log(this.editedItem)

        const response = await Api().post('golf/', this.editedItem)
        this.show = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('golf/' + this.editedItem.id, this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
        this.show = false
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/golf/InternalForm.vue